// ============================================
// gsap scrollTrigger
// ============================================
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import Lenis from "lenis";

// ============================================
// Lenis
// ============================================
export const lenis = new Lenis({
  autoRaf: true,
  lerp: 0.2,
  duration: 1.4,
  smoothTouch: true,
});

//初期設定
lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});
gsap.ticker.lagSmoothing(0);

// ============================================
// ページ内リンク
// ============================================
function lenisPageScroll() {
  const links = document.querySelectorAll(
    'a[href^="#"]:not(.-no-smooth, .l-header__skip-content)'
  );
  if (links.length === 0) return;

  const headerHeight = getComputedStyle(
    document.documentElement
  ).getPropertyValue("--size-header-h");
  const headerHeightNum = headerHeight.split("px")[0];

  links.forEach((target) => {
    target.addEventListener("click", (e) => {
      e.preventDefault();
      let targetLink = target.getAttribute("href");
      if (targetLink === "#") {
        targetLink = "body";
      }

      lenis.scrollTo(targetLink, {
        offset: Number(headerHeightNum) * -1,
        lerp: 0.2,
        duration: 1.2,
      });
    });
  });
}

// ============================================
// スクロールアニメーション
// ============================================
function inViewAnm() {
  gsap.utils.toArray(".js-inView").forEach((el) => {
    ScrollTrigger.create({
      //markers: true,
      trigger: el,
      start: "top 75%",
      end: "bottom 75%",
      once: true,
      toggleClass: {
        targets: el,
        className: "is-active",
      },
    });
  });
}

// ============================================
// 画像のパララックス
// ============================================
function imgAnim() {
  let animationY = -70;
  if (window.innerWidth < 1024) {
    animationY = -30;
  }
  const imgWrap = document.querySelectorAll(".js-imgParallax");
  if (imgWrap.length > 0) {
    imgWrap.forEach((item) => {
      const img = item.querySelectorAll(".js-imgParallax__item");
      gsap.utils.toArray(img).forEach((target, index) => {
        gsap.to(target, {
          y: animationY - 20 * (2 - index),
          ease: "power1.out",
          scrollTrigger: {
            trigger: item,
            start: () => "top 60%",
            end: () => "bottom 30%",
            scrub: 2,
          },
        });
      });
    });
  }
}
// ============================================
// 動画のパララックス
// ============================================
function movieAnim() {
  let animationY = -130;
  if (window.innerWidth < 1024) {
    animationY = -30;
  }
  const movieWrap = document.querySelectorAll(".js-movieParallax");
  if (movieWrap.length > 0) {
    movieWrap.forEach((item) => {
      const movie = item.querySelectorAll(".js-movieParallax__item");
      gsap.utils.toArray(movie).forEach((target, index) => {
        gsap.to(target, {
          y: animationY - 20 * (2 - index),
          ease: "power1.out",
          scrollTrigger: {
            trigger: item,
            start: () => "top 90%",
            end: () => "bottom 30%",
            scrub: 3,
          },
        });
      });
    });
  }
}

// ============================================
//  ナビを白色にする
// ============================================

function navWhite() {
  const header = document.querySelector(".js-header");
  const white = document.querySelectorAll(".js-nav-white");
  if (white.length > 0) {
    gsap.utils.toArray(white).forEach((el) => {
      ScrollTrigger.create({
        trigger: el,
        endTrigger: el,
        start: "top 5%",
        end: "bottom 5%",
        toggleClass: {
          targets: header,
          className: "is-active",
        },
      });
    });
  }
}

// ============================================
//  1文字ずつ発火するアニメーション
// ============================================

function textAnm() {
  const textWraps = document.querySelectorAll(".js-text");
  if (textWraps.length > 0) {
    textWraps.forEach((textWrap) => {
      const textIns = textWrap.querySelectorAll(".js-text__in");
      textIns.forEach((textIn, index) => {
        //読み上げ対策
        const textCont = textIn.textContent;
        textIn.setAttribute("aria-label", textCont);

        // 文字を一文字ずつ囲う
        const spannedText = Array.from(textCont)
          .map(
            (char) =>
              `<span class="js-text__in-char" aria-hidden="true">${char}</span>`
          )
          .join("");
        textIn.innerHTML = spannedText;

        //文字に対してアニメーションをつける

        //発火のスタイル
        function anmActive() {
          const charAry = textWrap.querySelectorAll(".js-text__in-char");
          for (let index = 0; index < charAry.length; index++) {
            Object.assign(charAry[index].style, {
              opacity: 0,
              transitionDelay: index * 0.06 + "s",
            });
          }
        }

        const charAry = textWrap.querySelectorAll(".js-text__in-char");
        anmActive();

        //scrollで発火
        if (textWrap.classList.contains("-js-scroll")) {
          ScrollTrigger.create({
            trigger: textWrap,
            start: "top 75%",
            end: "bottom 75%",
            once: true,
            onEnter: () => {
              anmStart(charAry);
            },
          });
        }

        //topのmv
        if (textWrap.classList.contains("-js-top")) {
          // setTimeout(() => {
          //   const charAry = textIns[0].querySelectorAll(".js-text__in-char");
          //   anmActive();
          //   anmStart(charAry);
          // }, 300);
          // setTimeout(() => {
          //   const charAry = textIns[1].querySelectorAll(".js-text__in-char");
          //   anmActive();
          //   anmStart(charAry);
          // }, 12000);
          setTimeout(() => {
            const charAry = textIns[0].querySelectorAll(".js-text__in-char");
            const charAry02 = textIns[1].querySelectorAll(".js-text__in-char");
            anmActive();
            anmStart(charAry);
            anmStart(charAry02);
          }, 300);
        }
      });
    });

    //発火後のスタイル
    function anmStart(elm) {
      for (let index = 0; index < elm.length; index++) {
        Object.assign(elm[index].style, {
          opacity: 1,
        });
      }
    }
  }
}

//スクロールに合わせて動画拡大
function imgUp() {
  const imgUp = document.querySelector(".js-up-movie");
  if (imgUp) {
    gsap.utils.toArray(imgUp).forEach((el) => {
      const item = imgUp.querySelector(".js-up-movie__item");
      const contents = imgUp.querySelector(".js-up-movie__contents");
      gsap.to(contents, {
        scale: "1",
        scrollTrigger: {
          trigger: item,
          start: "80px 40%",
          end: "+=3500px bottom",
          scrub: 0.5,
        },
      });
    });
  }
}

export {
  lenisPageScroll,
  inViewAnm,
  imgAnim,
  navWhite,
  textAnm,
  movieAnim,
  imgUp,
};
